import { Component, OnInit } from '@angular/core';
import { Step, Term, ModalService } from '@fcp/lib-ui';
import { of, Observable } from 'rxjs';
import {
  CMSAuthService,
  Token,
} from '../../essentials/cms/auth/cms-auth.service';
import { CMSContentService } from '../../essentials/cms/content/cms-content.service';
import { ActivatedRoute } from '@angular/router';

enum Planos {
  'Cristal Odonto' = 1,
  'Digna Saúde' = 2,
  'Essência' = 3,
  'Essência Pré' = 4,
  'Extensive' = 5,
  'NOSSO Plano' = 6,
  'PES-A - Plano Especial de Saúde' = 7,
  'PES-D - Plano Especial de Saúde' = 8
}

@Component({
  selector: 'fcp-filter-health-main',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.scss'],
})
export class FilterHealthComponent implements OnInit {
  public family;
  public currentStepIndex = 0;
  public filter: Step;
  public selectedImage: Observable<string>;
  public plans: Array<Term> = [];

  public btnHeaderRede = {
    title: 'Rede credenciada',
  };
  public btnFooterPrev = {
    title: 'Se você tem um plano de Saúde, acesse área exclusiva',
  };

  // public link = {
  //   url: '/',
  //   label: 'Já tenho um Plano Funcesp'
  // };

  constructor(
    private cmsAuthService: CMSAuthService,
    private cmsContentService: CMSContentService,
    private modalService: ModalService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    const paramBusca = this.activatedRoute.snapshot.queryParams['buscaRede'];
    if (paramBusca) {
      this.modalService.open({
        tabs: null,
        buttons: null,
        data: [Planos[paramBusca]],
        img: '',
        title: '',
        titleTabs: null,
        subtitleTabs: null,
        type: 'Rede Credenciada',
        text: null
      });
    }
    window?.scrollTo(0, 0);
    this.load();
  }

  load() {
    let token = this.cmsAuthService.getToken();
    if (!token) {
      this.cmsAuthService.auth().subscribe((newToken: Token) => {
        token = newToken.token_type + ' ' + newToken.access_token;
        this.cmsAuthService.setToken(token);
        this.getContent();
      });
    } else {
      this.getContent();
    }
  }

  getContent() {
    this.cmsContentService.getFilterHealth().subscribe((filter) => {
      this.filter = filter[0];
    });

    this.cmsContentService.getHealthFamily().subscribe((family) => {
      family.forEach((provider) => {
        provider.childrens.sort(this.sortByAlfhabet);
        // provider.childrens.forEach(plan => {
        //   plan.childrens.sort(this.sortByAlfhabet);
        // });
      });

      this.family = family.sort(this.sortByAlfhabet);
    });
  }

  private sortByAlfhabet(a, b) {
    return a.title.localeCompare(b.title);
  }

  searchPlans(term: string) {
    this.plans = this.family.filter((item) => {
      if (item.id === term) {
        return item.childrens;
      }
    });
  }

  public selectFamily(term: string) {
    this.searchPlans(term);
    this.currentStepIndex = 1;
  }

  public clearTerm(term) {
    this.currentStepIndex = 0;
  }

  public openModal() {
    this.modalService.open({
      tabs: null,
      buttons: null,
      data: null,
      img: '',
      title: '',
      titleTabs: null,
      subtitleTabs: null,
      type: 'Rede Credenciada',
      text: null,
    });
  }
}
